import { useEffect } from 'react';

import { type GetServerSideProps } from 'next';

import { AccountWrapper } from '@vakantiesnl/components/src/blocks/AccountWrapper';
import { BookingsOverview } from '@vakantiesnl/components/src/organisms/BookingsOverview';
import { withGlobalStateGSSP } from '@vakantiesnl/components/src/utils/globalState/withGlobalState';
import { getCachedContentTemplateFromContentful } from '@vakantiesnl/services/src/contentfulTemplates';
import { withAuthGSSP } from '@vakantiesnl/services/src/util/withAuth';
import { type ContentTemplate } from '@vakantiesnl/types/src';

import DefaultLayout from '../../layout';
import { type GlobalPageProps, type VaknlNextPage } from '../_app';

type Props = GlobalPageProps & {
	content: ContentTemplate;
};
const Bookings: VaknlNextPage<Props> = ({ content }) => {
	/** Fire page_view event on load of the page */
	useEffect(() => {
		import('@vakantiesnl/services/src/gtm/common').then(({ track }) =>
			import('@vakantiesnl/services/src/gtm/userLogin').then(({ userLoginPageView }) => {
				track(userLoginPageView(content.seo.slug));
			}),
		);
	}, [content.seo.slug]);

	return (
		<AccountWrapper pageContent={content}>
			<BookingsOverview content={content} />
		</AccountWrapper>
	);
};

export const getServerSideProps = withAuthGSSP(
	withGlobalStateGSSP(
		(globalState): GetServerSideProps<Props> =>
			async () => {
				try {
					const content = await getCachedContentTemplateFromContentful(
						`/${process.env.NEXT_PUBLIC_USER_BASE_PATH}/mijn-boekingen`,
					);

					return {
						props: {
							globalState,
							content,
							seo: content.seo,
						},
					};
				} catch (err) {
					// eslint-disable-next-line no-console
					console.error('Error in getServerSideProps on bookings page: ', err);

					return {
						notFound: true,
					};
				}
			},
	),
);

Bookings.Layout = DefaultLayout;

export default Bookings;
